import { ADMIN_ROLE_SLUG, FFL_ROLE_SLUG } from 'config/app.config';
import { placeParamsToURL } from 'helpers/CommonHelper';
import { t } from 'i18next';
import { adminMainRoutes, loginRoutes } from 'routes/admin/AdminRoutes';
import { userCurrentRoleSlugSelector } from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';

/**
 * The storefront's FFL / admin shortcut - shared by the web top bar and the mobile / tablet
 * side menu so both always show the same label. Logged-in FFL/admin accounts get a link
 * straight to their dashboard instead of the generic "FFL Login" prompt, which only makes
 * sense for a signed-out visitor.
 */
export default function useDashboardLink() {
  const currentRoleSlug = useAppSelector(userCurrentRoleSlugSelector);

  if (currentRoleSlug === FFL_ROLE_SLUG) {
    return {
      label: t('ffl_dashboard', 'FFL Dashboard'),
      path: placeParamsToURL(adminMainRoutes.dashboard.path),
      isDashboard: true,
    };
  }
  if (currentRoleSlug === ADMIN_ROLE_SLUG) {
    return {
      label: t('admin_dashboard', 'Admin Dashboard'),
      path: placeParamsToURL(adminMainRoutes.dashboard.path),
      isDashboard: true,
    };
  }
  return {
    label: t('customer_ffl_login'),
    path: placeParamsToURL(loginRoutes.login.path),
    isDashboard: false,
  };
}
